module.exports = __webpack_public_path__ + "assets_1789457014240/img/pic_4.427fca0b.png";